import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import BankDetails from "./BankDetails";
import { X } from "lucide-react";
import UserAccount from "./UserAccount";
import axios from "axios";
import { MdMenu } from "react-icons/md";
import UpiId from "../UserAccount/UpiId";
import { MyContext } from "../../../context/MyContext";
import NomineeDetail from "./NomineeDetail";

export default function BankDetailsTable() {
  const {
    data,
    bankdata,
    Disable,
    setDisable,
    upiDisable,
    nomineeData,
    upiDetail,
  } = useContext(MyContext);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  // const [Disable, setDisable] = useState(false);
  const [userAccount, setUserAccount] = useState(false);
  // const [bankdata, setBankdata] = useState(false);
  //   const [data, setData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenModal, setIsOpenModel] = useState(false);
  const [showUserAccount, setShowUserAccount] = useState(false);

  const handleEditClick = (item) => {
    setSelectedBank(item);
    setIsOpen(true);
  };
  function handleFormSubmission() {
    setIsOpen(false);
    setDisable(true);
  }
  function closeForm() {
    setIsOpen(false);
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    
  }, [isOpen, setIsOpen]);

  const toggleUserAccount = () => {
    setUserAccount((prev) => !prev);
  };
  const { MLMStatus, verifyMlmUser } = useContext(MyContext);

  return (
    <>
  <div className={`flex flex-col md:flex-row w-full pt-4 md:pt-2 ${verifyMlmUser ? "lg:pt-[100px]" : "lg:pt-40"}`}>
    {/* Sidebar */}
    <div
      className={`${
        userAccount ? "block" : "hidden"
      } md:block absolute md:relative bg-white shadow-md p-4 z-10 w-full md:w-auto`}
    >
      <UserAccount showUserAccount={setUserAccount} />
    </div>

    {/* Main Content */}
    <div className="p-4 sm:p-6 md:p-8 w-full">
      {/* Menu for smaller screens */}
      <div className="flex justify-end md:hidden mb-4">
        <MdMenu
          onClick={toggleUserAccount}
          className="text-4xl cursor-pointer border rounded-lg px-1"
        />
      </div>

      {/* Page Header & Buttons */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <h1 className="font-bold text-xl md:text-2xl text-purple-600 flex-1">
          Bank Details
        </h1>

        <button
          onClick={() => {
            setSelectedBank(null);
            setIsOpen(true);
          }}
          disabled={Disable}
          className={`rounded-md h-10 px-4 text-white ${
            Disable ? "bg-gray-400 cursor-not-allowed" : "bg-purple-500"
          }`}
        >
          Add Bank Details
        </button>

        <button
          onClick={() => setIsModalOpen(true)}
          disabled={upiDisable}
          className={`rounded-md h-10 px-4 text-white ${
            upiDisable ? "bg-gray-400 cursor-not-allowed" : "bg-purple-500"
          }`}
        >
          Add UPI ID
        </button>

        <button
          className={`rounded-md h-10 px-4 text-white ${
            nomineeData ? "bg-gray-400 cursor-not-allowed" : "bg-purple-500"
          }`}
          onClick={() => setIsOpenModel(true)}
          disabled={nomineeData}
        >
          Add Nominee Detail
        </button>
      </div>

      {/* Bank Table */}
      {data && (
        <div className="w-full overflow-x-auto">
          <table className="min-w-[600px] w-full border-2 border-purple-600">
            <thead>
              <tr>
                {["Sl No.", "Account Holder Name", "Bank Name", "Account Number", "IFSC Code"].map(
                  (heading, idx) => (
                    <th
                      key={idx}
                      className="border-2 border-purple-500 px-2 py-1 text-purple-500 text-sm"
                    >
                      {heading}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              <tr className="text-center text-sm">
                <td className="border-2 border-purple-500 px-2 py-1">
                  {data?.slNo || "1"}
                </td>
                <td className="border-2 border-purple-500 px-2 py-1">
                  {data?.account_holder_name}
                </td>
                <td className="border-2 border-purple-500 px-2 py-1">
                  {data?.bank_name}
                </td>
                <td className="border-2 border-purple-500 px-2 py-1">
                  {data?.account_number}
                </td>
                <td className="border-2 border-purple-500 px-2 py-1">
                  {data?.ifsc_code}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Nominee Table */}
      {nomineeData && (
        <div className="mt-6">
          <h2 className="text-2xl font-semibold text-purple-600 mb-2">
            Nominee Details
          </h2>
          <div className="w-full overflow-x-auto">
            <table className="min-w-[700px] w-full border-2 border-purple-600">
              <thead>
                <tr>
                  {[
                    "Sl No.",
                    "Nominee Name",
                    "Nominee Address",
                    "Nominee DOB",
                    "Aadhar Number",
                    "Pan Number",
                  ].map((title, idx) => (
                    <th
                      key={idx}
                      className="border-2 border-purple-500 px-2 py-1 text-purple-500 text-sm"
                    >
                      {title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="text-center text-sm">
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {nomineeData?.slNo || "1"}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {nomineeData?.nominee_name}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {nomineeData?.nominee_address}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {nomineeData?.nominee_dob}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {nomineeData?.addharNumber}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {nomineeData?.panNumber}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* UPI Table */}
      {upiDetail && (
        <div className="mt-6">
          <h2 className="text-2xl font-semibold text-purple-600 mb-2">
            UPI Details
          </h2>
          <div className="w-full overflow-x-auto">
            <table className="min-w-[400px] w-full border-2 border-purple-600">
              <thead>
                <tr>
                  {["Sl No.", "UPI Name", "UPI ID"].map((item, idx) => (
                    <th
                      key={idx}
                      className="border-2 border-purple-500 px-2 py-1 text-purple-500 text-sm"
                    >
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="text-center text-sm">
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {upiDetail?.slNo || "1"}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {upiDetail?.upiName}
                  </td>
                  <td className="border-2 border-purple-500 px-2 py-1">
                    {upiDetail?.upiId}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal for Add Bank Details */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4 z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="bg-white p-6 rounded-2xl relative w-full max-w-lg"
          >
            <button
              className="absolute top-4 right-4"
              onClick={() => setIsOpen(false)}
            >
              <X className="w-5 h-5" />
            </button>

            <BankDetails
              bankData={selectedBank}
              bankdata={data}
              existBank={bankdata}
              handleForm={closeForm}
            />
          </motion.div>
        </div>
      )}
    </div>
  </div>

  {/* UPI & Nominee Modals */}
  {isModalOpen && <UpiId onClose={() => setIsModalOpen(false)} />}
  {isOpenModal && <NomineeDetail onClose={() => setIsOpenModel(false)} />}
</>

  );
}
